import { apiClient } from '../utils/apiClient';
import type {
    GetUserApiKeyResponse,
    UpsertUserApiKeyRequest,
    UpsertUserApiKeyResponse,
    DeleteUserApiKeyResponse,
} from '@arrowise/shared';
import { validateSchemaSync, upsertUserApiKeySchema } from '@arrowise/shared';
import { teamService } from './teamService';

class KeyService {
    async getUserKeyInfo(): Promise<GetUserApiKeyResponse> {
        const response = await apiClient.get<GetUserApiKeyResponse>('/keys');
        if (!response.success || !response.data) throw new Error(response.message || 'Failed to fetch API key info');
        return response.data;
    }

    async upsertUserKey(payload: UpsertUserApiKeyRequest): Promise<UpsertUserApiKeyResponse> {
        const validation = validateSchemaSync(upsertUserApiKeySchema, payload);
        if (!validation.success || !validation.data) {
            throw new Error('Invalid API key payload');
        }
        const response = await apiClient.put<UpsertUserApiKeyResponse>('/keys', validation.data);
        if (!response.success || !response.data) throw new Error(response.message || 'Failed to save API key');
        return response.data;
    }

    async deleteUserKey(): Promise<void> {
        const response = await apiClient.delete<DeleteUserApiKeyResponse>('/keys');
        if (!response.success) throw new Error(response.message || 'Failed to delete API key');
        try {
            const { teams } = await teamService.getUserTeams();
            for (const info of teams) {
                if (info.isOwner && info.team.keyMode === 'byok') {
                    await teamService.updateTeamKeyMode(info.team.id, 'default');
                }
            }
        } catch (_err) {
            // best effort; ignore
        }
    }
}

export const keyService = new KeyService();
export default keyService;


